import { Step } from 'react-dsgov';
import styles from './customStep.module.scss';
import { useEffect } from 'react';

export interface ICustomStepProps {
  setStepFormulario: React.Dispatch<React.SetStateAction<number>>;
  stepAtual: number;
  steps: {
    label: string;
    status?: 'success' | 'warning' | 'info' | 'danger' | undefined;
  }[];
  withSuccess?: boolean;
}

function CustomStep({ steps, stepAtual, withSuccess = true }: Readonly<ICustomStepProps>) {
  useEffect(() => {
    const nextStep = () => {
      steps.forEach((step, index) => {
        if (index + 1 < stepAtual && withSuccess) {
          step.status = 'success';
        }
      });
    };
    nextStep();
  }, [stepAtual, steps, withSuccess]);

  return (
    <div className={styles.container}>
      <Step orientation='vertical' value={stepAtual} labelPosition='left' steps={steps} className={styles.step} />
    </div>
  );
}

export default CustomStep;
